<form
  [formGroup]="form"
  class="pb-xl">
  <ng-container formGroupName="locationCardSettings">
    <label>{{ 'MAP-DISPLAY.LOCATION-ELEMENTS' | translate }}</label>
    <div class="widget-element-settings-container mb-lg">
      <div class="box">
        <div class="settings-group">
          <i class="icon icon-flag_solid"></i>
          <span>{{ 'MAP-DISPLAY.FLAG' | translate }}</span>
          <topo-switch formControlName="showFlag" />
        </div>
      </div>

      <div class="box">
        <div class="settings-group">
          <i class="icon icon-time_clock_1"></i>
          <span>{{ 'MAP-DISPLAY.TIME' | translate }}</span>
          <topo-switch formControlName="showTime" />
        </div>
        @if (form.get('locationCardSettings').get('showTime').value) {
          <div class="additional-settings">
            <label>{{ 'MAP-DISPLAY.TIME-FORMAT' | translate }}</label>
            <div class="radio-list">
              <label class="radio">
                <input
                  type="radio"
                  [value]="timeFormatShort"
                  name="timeFormat"
                  formControlName="timeFormat" />
                {{ timeFormatShortSample }}&nbsp;{{ 'MAP-DISPLAY.TIME-12-SAMPLE' | translate }}
              </label>
              <label class="radio">
                <input
                  type="radio"
                  [value]="timeFormat24h"
                  name="timeFormat"
                  formControlName="timeFormat" />
                {{ timeFormat24hSample }}&nbsp;{{ 'MAP-DISPLAY.TIME-24-SAMPLE' | translate }}
              </label>
            </div>
          </div>
        }
      </div>

      <div class="box">
        <div class="settings-group">
          <i class="material-icons">thermostat</i>
          <span>{{ 'MAP-DISPLAY.TEMPERATURE' | translate }}</span>
          <topo-switch formControlName="showTemperature" />
        </div>
        @if (form.get('locationCardSettings').get('showTemperature').value) {
          <div class="additional-settings">
            <label>{{ 'MAP-DISPLAY.TEMPERATURE-UNITS' | translate }}</label>
            <div class="radio-list">
              <label class="radio">
                <input
                  type="radio"
                  [value]="false"
                  name="tempUnitsCelcius"
                  formControlName="tempUnitsCelcius" />
                {{ 'MAP-DISPLAY.FAHRENHEIT' | translate }}
              </label>
              <label class="radio">
                <input
                  type="radio"
                  [value]="true"
                  name="tempUnitsCelcius"
                  formControlName="tempUnitsCelcius" />
                {{ 'MAP-DISPLAY.CELSIUS' | translate }}
              </label>
            </div>
          </div>
        }
      </div>

      <div class="box">
        <div class="settings-group">
          <i class="icon icon-sun_fog"></i>
          <span>{{ 'MAP-DISPLAY.WEATHER' | translate }}</span>
          <topo-switch formControlName="showWeather" />
        </div>
      </div>

      <div class="box">
        <div class="settings-group">
          <i class="icon icon-zoom-to_globe"></i>
          <span>{{ 'MAP-DISPLAY.WORLD' | translate }}</span>
          <topo-switch formControlName="showWorld" />
        </div>
        @if (form.get('locationCardSettings').get('showWorld').value) {
          <div class="additional-settings">
            <label>{{ 'MAP-DISPLAY.WORLD-CARD-FORMAT' | translate }}</label>
            <div class="radio-list mb-lg">
              <label class="radio">
                <input
                  type="radio"
                  value="MMMM D, YYYY"
                  name="worldTimeFormat"
                  formControlName="worldTimeFormat" />
                {{ 'MAP-DISPLAY.WORLD-DATE-SAMPLE1' | translate }}
              </label>
              <label class="radio">
                <input
                  type="radio"
                  value="D MMMM YYYY"
                  name="worldTimeFormat"
                  formControlName="worldTimeFormat" />
                {{ 'MAP-DISPLAY.WORLD-DATE-SAMPLE2' | translate }}
              </label>
              <label class="radio">
                <input
                  type="radio"
                  value="ddd MMMM D"
                  name="worldTimeFormat"
                  formControlName="worldTimeFormat" />
                {{ 'MAP-DISPLAY.WORLD-DATE-SAMPLE3' | translate }}
              </label>
              <label class="radio">
                <input
                  type="radio"
                  value="ddd D MMMM"
                  name="worldTimeFormat"
                  formControlName="worldTimeFormat" />
                {{ 'MAP-DISPLAY.WORLD-DATE-SAMPLE4' | translate }}
              </label>
            </div>

            <label>{{ 'MAP-DISPLAY.SHOW-DAY-NIGHT' | translate }}</label>
            <topo-switch formControlName="worldShowDayNight" />
          </div>
        }
      </div>
    </div>

    <div class="mb-lg">
      <label>{{ 'MAP-DISPLAY.ORDER-BY-LONGTITUDE' | translate }}</label>
      <topo-switch formControlName="orderByLongitude" />
    </div>

    <div>
      <label>{{ 'MAP-DISPLAY.TRANSITION-TIME' | translate }}</label>
      <div class="transition-time-input-wrapper">
        <input
          class="input is-small"
          type="number"
          min="1"
          formControlName="transitionTimeSeconds" />
        <span>{{ 'MAP-DISPLAY.SECONDS' | translate }}</span>
      </div>
    </div>
  </ng-container>
</form>
